import { useQuery } from "@tanstack/react-query";
import { api } from "@/api";

export const cartKeys = {
	all: ["carts"] as const,
};

export function useCarts() {
	return useQuery({
		queryKey: cartKeys.all,
		queryFn: () => api.carts.list(),
	});
}
